// ============================================================================
// REPOSITORY: TemplateRepository — Templates de contratos e procuracoes
// ARQUIVO: src/services/TemplateRepository.js
// ============================================================================

import {
  doc,
  getDoc,
  setDoc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../shared/api/firebase/config";

const DEFAULT_APP_ID = "portalrda-f312d";

// --- Contract Templates ---

// FS.documents(appId) é um helper de COLEÇÃO ("artifacts/{appId}/public/
// data/documents", 5 segmentos, pensado para usar com collection() — ver
// comentário em firestorePaths.js). As 5 funções abaixo o usavam com
// doc(), criando um path de 7 segmentos (ímpar = inválido: "Invalid
// document reference. Document references must have an even number of
// segments"). O mestre real do Contrato está em "artifacts/{appId}/
// public/data/contract_templates/master_v8" (6 segmentos), sem o
// "documents" no meio — mesmo padrão que CONTRACT_TEMPLATES_ROOT abaixo
// e que PROCURATION_TEMPLATES_ROOT já usa corretamente mais abaixo neste
// arquivo. Bug pré-existente (não introduzido nesta sessão, presente
// desde o commit que criou este arquivo); achado ao clicar em "Avançado
// > Baixar Mestre da Nuvem" no Contrato.
const CONTRACT_TEMPLATES_ROOT = (appId) => [
  "artifacts",
  appId,
  "public",
  "data",
  "contract_templates",
];

export async function getContractMaster(appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...CONTRACT_TEMPLATES_ROOT(appId), "master_v8");
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function setContractMaster(payload, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...CONTRACT_TEMPLATES_ROOT(appId), "master_v8");
  await setDoc(
    ref,
    { ...payload, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

export function subscribeContractMaster(appId, callback) {
  const ref = doc(db, ...CONTRACT_TEMPLATES_ROOT(appId), "master_v8");
  return onSnapshot(ref, (snap) =>
    callback(snap.exists() ? { id: snap.id, ...snap.data() } : null),
  );
}

export async function getContractAutosave(docId, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...CONTRACT_TEMPLATES_ROOT(appId), docId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function setContractAutosave(
  docId,
  payload,
  appId = DEFAULT_APP_ID,
) {
  const ref = doc(db, ...CONTRACT_TEMPLATES_ROOT(appId), docId);
  await setDoc(
    ref,
    { ...payload, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

// --- Procuration Templates ---

const PROCURATION_TEMPLATES_ROOT = (appId) => [
  "artifacts",
  appId,
  "public",
  "data",
  "procuration_templates",
];

export async function getProcurationMaster(appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), "master_v1");
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function setProcurationMaster(payload, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), "master_v1");
  await setDoc(
    ref,
    { ...payload, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

export async function fetchProcurationMaster(appId) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), "master_v1");
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export function subscribeProcurationMaster(appId, callback) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), "master_v1");
  return onSnapshot(ref, (snap) =>
    callback(snap.exists() ? { id: snap.id, ...snap.data() } : null),
  );
}

export async function getProcurationAutosave(docId, appId = DEFAULT_APP_ID) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), docId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function setProcurationAutosave(
  docId,
  payload,
  appId = DEFAULT_APP_ID,
) {
  const ref = doc(db, ...PROCURATION_TEMPLATES_ROOT(appId), docId);
  await setDoc(
    ref,
    { ...payload, updatedAt: serverTimestamp() },
    { merge: true },
  );
}
